export const filters = {
	searchPlaceholder: "Search products...",
	clearSearch: "Clear search",
	allProducts: "All products",
	activeProducts: "Active products",
	inactiveProducts: "Inactive products",
	viewByCategory: "View by Category",
	viewByMenuCategory: "View by Menu Category",
	clearFilters: "Clear filters",
};
